module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/panel_background@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoBetBar/panel_background@2x.png
// module id = 203
// module chunks = 0